// Proxy for env vars
//
// The file rather than the `@/shared/lib` barrel, deliberately: traforama's auth bundle is
// 69 modules and reaches this one, so pulling the barrel in here would drag the whole of
// `shared/lib` — element-plus wrappers, tanstack helpers, the amCharts loader — into a
// login page that imports none of it today.
import { transformKeys } from '@/shared/lib/transformKeys'
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
import.meta.env.VITE_DOMAIN
const appEnv: any = transformKeys(import.meta.env, (key) =>
  key.replace('VITE_', '').replace('VUE_APP_', '')
)
export default appEnv
